import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'

export const Walk = {
  namespaced: true,
  state: {
    weekInfo: null,
    stamps: [],
    thisWeek: [],
    weekly: [],
    monthly: [],
    stepSummary: { avg_month: 0, avg_week: 0, total: 0 },
    isGetStamp: false,
    numGivingStamp: 1,
    lastStampAt: null
  },
  getters: {
    weekInfo: state => state.weekInfo,
    stamps: state => state.stamps,
    thisWeek: state => state.thisWeek,
    weekly: state => state.weekly,
    monthly: state => state.monthly,
    stepSummary: state => state.stepSummary,
    isGetStamp: state => state.isGetStamp,
    numGivingStamp: state => state.numGivingStamp,
    lastStampAt: state => state.lastStampAt
  },
  mutations: {
    UPDATE_WALKS(state, payload) {
      state.weekInfo = payload['weekInfo']
      state.stamps = payload['stamps']
      state.thisWeek = payload['thisWeek']
      state.weekly = payload['weekly']
      state.monthly = payload['monthly']
      state.lastHistoryAt = payload['lastHistoryAt']
      state.total = payload['total']
      state.stepSummary = payload['stepSummary']
      state.isGetStamp = payload['isGetStamp']
      state.numGivingStamp = payload['numGivingStamp']
      state.lastStampAt = payload['lastStampAt']
    }
  },
  actions: {
    /**
     * スタンプ獲得履歴の取得
     *
     * @param {*} param0
     * @param {*} payload
     */
    async actionFetchWalks({ commit }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime
      const steps = payload.steps
      let res = null
      if (token !== '') {
        res = await APIClient.getWalkHistories(token, accTime, userId, steps)
      } else {
        const error = {
          code: ErrorCode.CODE_ERROR_TOKEN,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        commit('UPDATE_WALKS', res.data.data)
      } else {
        const error = {
          code: res.data.data.code,
          message: res.data.data.message
        }
        throw error
      }
    }
  }
}
